import { IEntity } from "@messaia/cdk";

export class Sepa implements IEntity {
	id: number;
	accountHolder: string;
	iban: string;
	bic: string;
	bankName: string;
}